import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../../store/actions/authActions";
import bodyClassController from "../../store/utils/bodyClassController";
import setPageData from "../../store/actions/setPageData";
import 'react-range-slider-input/dist/style.css';
import Header from '../../components/default/header';
import CardChart from "../../components/card-chart/card-chart";
import GlobalSidebarMenu from "../default/header/globalSidebarMenu";
class DashboardScreenDtl extends React.Component {

	render() {
		let { pageData } = this.props;


		return (
			<div className="sidebar-menu-enable dashboard">
				<Helmet><title>Cardiast Digital Business Card</title></Helmet>
				<Header />
				<div className="sidebar-with-content ds-flex">
					<div className="card-menu-wrapper">
						<div className="sticky-area has-top-level-menu">
							<div className="top-level-menu">
								<GlobalSidebarMenu sidebarTitle="" />
							</div>
						</div>
					</div>
					<div className="content-right">
						<CardChart />
					</div>
				</div>
			</div>
		);

	}

}

const mapStateToProps = (state) => ({
	auth: state.auth,
	pageData: state.pageData,
	leadData: state.leadData,
});
const mapDispatchToProps = {
	logout,
	setPageData,
	bodyClassController,
};


function DashboardScreen(props) {
	let navigate = useNavigate();
	return <DashboardScreenDtl {...props} navigate={navigate} />
}
export default connect(mapStateToProps, mapDispatchToProps)(DashboardScreen);
